<template>
  <section class="cart">
    <div class="header">
      <div class="cart__items">
        <h2 class="cart__title">Meu Carrinho</h2>
        <div class="product" v-for="(cart, index) in carrinho" :key="index">
          <div class="product__details">
            <div class="details__image">
              <a @click="productDetails(cart.sku, cart.valor)">
                <img :src="cart.imagem" :alt="cart.nomeItem" width="90px" />
              </a>
            </div>
            <div class="details__infos">
              <p>
                <a @click="productDetails(cart.sku, cart.valor)">
                  {{ cart.nomeItem }}
                </a>
              </p>
              <p>
                SKU: <span>{{ cart.sku }}</span>
              </p>
              <p>Vendido e Entregue por <strong>Leveros</strong></p>
              <p v-if="cart.sla == null">Entrega: <span>a calcular</span></p>
              <p v-if="cart.sla == 1">
                Entrega: <span>{{ cart.sla }} dia útil</span>
              </p>
              <p v-if="cart.sla > 1">
                Entrega: <span>{{ cart.sla }} dias úteis</span>
              </p>
            </div>
            <div class="details__remove">
              <a href="#" @click="excluirProdutoCheckoutCarrinho(cart.sku)"
                ><svg
                  id="Layer_1"
                  data-name="Layer 1"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="#005A64"
                  width="20px"
                  viewBox="0 0 24 24"
                >
                  <title>spam, trash, close, garbage, delete</title>
                  <path
                    d="M2.88,5,5.11,24H18.89L21.12,5ZM17.11,22H6.89L5.12,7H18.88Z"
                  />
                  <polygon
                    points="21 2 15 2 15 1 13 1 13 0 11 0 11 1 9 1 9 2 3 2 3 4 21 4 21 2"
                  />
                  <polygon
                    points="10.23 17.66 12 15.89 13.77 17.66 15.18 16.24 13.41 14.47 15.18 12.71 13.77 11.29 12 13.06 10.23 11.29 8.82 12.71 10.59 14.47 8.82 16.24 10.23 17.66"
                  /></svg
              ></a>
            </div>
          </div>
          <div class="product__controller">
            <div class="controller__quantity">
              <p>Quantidade:</p>
              <button
                title="Diminuir quantidade"
                @click="diminuirItensCheckoutCarrinho(cart.sku)"
                v-if="!cart.isCustomized"
              >
                -
              </button>
              <input type="text" :value="cart.quantidade" disabled="true" />
              <button
                title="Aumentar quantidade"
                @click="aumentarItensCheckoutCarrinho(cart.sku, cart.estoque)"
                v-if="!cart.isCustomized"
              >
                +
              </button>
            </div>
            <div class="controller__values">
              <p>{{ (cart.valor * cart.quantidade) | toCurrency }}</p>
            </div>
          </div>
        </div>

        <div class="freight">
          <h3 class="freight__title">Simule o frete e prazo de entrega</h3>
          <div class="freight__form">
            <the-mask
              mask="#####-###"
              v-model="cep"
              type="text"
              placeholder="Informe seu CEP"
              :masked="false"
              @change="calcularFrete"
              class="minicart__input"
            />
            <button @click="calcularFrete">Calcular</button>
            <p><a href="">Não sei meu CEP</a></p>
          </div>
          <div class="freight__result">
            <div class="loader" v-if="loader">
              <span><i class="fas fa-stroopwafel fa-spin fa-3x"></i></span>
              <span>Calculando frete...</span>
            </div>
            <v-radio-group v-if="!loader">
              <v-radio
                v-for="s in sla"
                :key="s.tipo"
                :label="s.textoFrete"
                @change="selecionaSLA(s)"
                :value="s.sla"
              ></v-radio>
            </v-radio-group>
          </div>
        </div>
      </div>
      <div class="cart__summary">
        <h2 class="cart__title">Resumo do Carrinho</h2>
        <div class="cart__values">
          <div class="summary__values">
            <div class="summary__item">
              <div class="item__label">Subtotal</div>
              <div class="item__value">{{ totalCarrinho | toCurrency }}</div>
            </div>
            <div class="summary__item">
              <div class="item__label">Entrega</div>
              <div class="item__value" v-if="slaSelecionado == null">
                A calcular
              </div>
              <div class="item__value" v-if="slaSelecionado != null">
                {{ slaSelecionado.preco | toCurrency }}
              </div>
            </div>
            <div class="summary__item">
              <div class="item__label">Valor Total</div>
              <div class="item__value" v-if="slaSelecionado != null">
                {{ (totalCarrinho + slaSelecionado.preco) | toCurrency }}
              </div>
              <div class="item__value" v-if="slaSelecionado == null">
                {{ totalCarrinho | toCurrency }}
              </div>
            </div>
          </div>

          <div class="summary__buttons">
            <router-link to="/checkout" class="summary__continue"
              >CONTINUAR</router-link
            >
            <router-link to="/" class="summary__buyMore"
              >ESCOLHER MAIS PRODUTOS</router-link
            >
          </div>
        </div>
      </div>
    </div>

    <div class="buyMore" v-if="!isSaleSolar">
      <h2 class="buyMore__title">Aproveite e compre também:</h2>
      <div class="products">
        <div class="products__item">
          <div class="products__loader" v-if="loader">
            <span><i class="fas fa-stroopwafel fa-spin fa-3x"></i></span>
            <span
              >Aguarde, enquanto trazemos os melhores produtos para você!</span
            >
          </div>
          <div
            class="products__list"
            v-for="(info, index) in infos.slice(0, 4)"
            :key="index"
          >
            <a @click="productDetails(info.SKU, info.vl_liquido_produto)">
              <img
                loading="lazy"
                class="products__image"
                :src="info.ImagemItem"
                :alt="info.Ds_Item"
              />
            </a>
            <p class="products__name">
              {{ info.Ds_Item }}
            </p>
            <div class="products__price">
              <span class="products__pricePer" v-if="info.estoque >= 1">
                {{ (info.vl_liquido_produto * 0.95) | toCurrency }}
                <span class="products__AtSight">à vista</span></span
              >
              <span class="products__priceTerm">
                ou <span> {{ info.vl_liquido_produto | toCurrency }}</span>
              </span>
              <span
                class="products__plots"
                v-if="
                  info.vl_liquido_produto >= 195 &&
                  info.vl_liquido_produto < 220
                "
              >
                8x de
                {{ (info.vl_liquido_produto / 8) | toCurrency }}
                sem juros</span
              >
              <span
                class="products__plots"
                v-if="
                  info.vl_liquido_produto >= 175 &&
                  info.vl_liquido_produto <= 194
                "
              >
                7x de
                {{ (info.vl_liquido_produto / 7) | toCurrency }}
                sem juros</span
              >
              <span
                class="products__plots"
                v-if="
                  info.vl_liquido_produto >= 155 &&
                  info.vl_liquido_produto <= 174
                "
              >
                6x de
                {{ (info.vl_liquido_produto / 6) | toCurrency }}
                sem juros</span
              >
              <span
                class="products__plots"
                v-if="
                  info.vl_liquido_produto >= 120 &&
                  info.vl_liquido_produto <= 173
                "
              >
                5x de
                {{ (info.vl_liquido_produto / 5) | toCurrency }}
                sem juros</span
              >
              <span
                class="products__plots"
                v-if="
                  info.vl_liquido_produto >= 100 &&
                  info.vl_liquido_produto <= 119
                "
              >
                4x de
                {{ (info.vl_liquido_produto / 4) | toCurrency }}
                sem juros</span
              >
              <span
                class="products__plots"
                v-if="
                  info.vl_liquido_produto >= 80 && info.vl_liquido_produto <= 99
                "
              >
                3x de
                {{ (info.vl_liquido_produto / 3) | toCurrency }}
                sem juros</span
              >
              <span
                class="products__plots"
                v-if="info.vl_liquido_produto <= 79"
              >
                2x de
                {{ (info.vl_liquido_produto / 2) | toCurrency }}
                sem juros</span
              >
              <span
                class="products__plots"
                v-if="info.vl_liquido_produto > 221"
              >
                10x de
                {{ (info.vl_liquido_produto / 10) | toCurrency }}
                sem juros</span
              >
              <span class="products__lowerQuantity" v-if="info.estoque <= 5"
                >Poucas Unidades</span
              >
              <span class="products__unavailable" v-if="info.estoque <= 0"
                >Não disponível :(</span
              >
            </div>
            <div class="products__buttons">
              <button
                class="products__buttons--details"
                @click="productDetails(info.SKU, info.vl_liquido_produto)"
              >
                <i class="fa fa-eye" aria-hidden="true"></i> Detalhes
              </button>
              <a
                href=""
                class="products__buttons--buy"
                @click="addMiniCart(info)"
              >
                <button>
                  <i class="fa fa-shopping-cart" aria-hidden="true"></i> +
                  Carrinho
                </button></a
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import axios from "axios";

export default {
  data: () => ({
    carrinho: [],
    totalItensCarrinho: 0,
    cep: null,
    sla: null,
    slaSelecionado: null,
    totalCarrinho: 0,
    loader: false,
    token: null,
    saleChannel: null,
    isSaleSolar: false,
    infos: [],
  }),

  methods: {
    selecionaSLA(sla) {
      this.slaSelecionado = sla;
    },

    async recuperarInfosProdutos() {
      let carrinho = JSON.parse(localStorage.getItem("carrinho"));
      let totalCarrinho = 0;
      carrinho.forEach(function (c) {
        totalCarrinho =
          parseFloat(totalCarrinho) +
          parseFloat(c.valor) * parseFloat(c.quantidade);
      });
      this.totalCarrinho = totalCarrinho;
      this.carrinho = carrinho;
    },

    async calculaTotalCarrinho() {
      let total = 0;
      let carrinho = JSON.parse(localStorage.getItem("carrinho"));
      carrinho.forEach(function (e) {
        total = parseFloat(total) + parseFloat(e.quantidade);
      });
      this.totalItensCarrinho = total;
    },

    diminuirItensCheckoutCarrinho(sku) {
      let carrinho =
        localStorage.getItem("carrinho") != "" ||
        localStorage.getItem("carrinho") == null ||
        localStorage.getItem("carrinho") == undefined
          ? JSON.parse(localStorage.getItem("carrinho"))
          : [];

      carrinho.forEach(function (e) {
        if (e.sku == sku) {
          if (e.quantidade > 1) {
            e.quantidade = e.quantidade - 1;
          }
        }
      });

      localStorage.setItem("carrinho", JSON.stringify(carrinho));
      this.calculaTotalCarrinho();
      this.recuperarInfosProdutos();
    },

    aumentarItensCheckoutCarrinho(sku, estoque) {
      let carrinho =
        localStorage.getItem("carrinho") != "" ||
        localStorage.getItem("carrinho") == null ||
        localStorage.getItem("carrinho") == undefined
          ? JSON.parse(localStorage.getItem("carrinho"))
          : [];

      carrinho.forEach(function (e) {
        if (e.sku == sku) {
          if (e.quantidade < estoque) {
            e.quantidade = e.quantidade + 1;
          }
        }
      });

      localStorage.setItem("carrinho", JSON.stringify(carrinho));
      this.calculaTotalCarrinho();
      this.recuperarInfosProdutos();
    },

    excluirProdutoCheckoutCarrinho(sku) {
      let carrinho =
        localStorage.getItem("carrinho") != "" ||
        localStorage.getItem("carrinho") == null ||
        localStorage.getItem("carrinho") == undefined
          ? JSON.parse(localStorage.getItem("carrinho"))
          : [];

      carrinho.forEach(function (e, i) {
        if (e.sku == sku) {
          carrinho.splice(i, 1);
        }
      });

      if (carrinho.length == 0) {
        document.getElementsByClassName("minicart__closeMiniCart")[0].click();
        document.getElementsByClassName("header__quantity")[0].innerText = 0;
      }
      localStorage.setItem("carrinho", JSON.stringify(carrinho));
      this.calculaTotalCarrinho();
      this.recuperarInfosProdutos();
    },

    async calcularFrete() {
      this.loader = true;
      if (this.cep != null) {
        let items = [];
        let carrinho = JSON.parse(localStorage.getItem("carrinho"));
        let saleschannel = JSON.parse(localStorage.getItem("saleChannel"));
        let quantidade_total = 0;
        carrinho.forEach(function (e) {
          let _items = {
            idSku: e.sku,
            quantidade: e.quantidade,
            price: e.valor * e.quantidade,
          };
          quantidade_total = quantidade_total + e.quantidade;
          items.push(_items); 
        });
        let body = {
          location: {
            zipCode: this.cep.replace("-", ""),
          },
          saleschannel: saleschannel,
          items: items,
        };
        let simularFrete = await axios({
          method: "post",
          data: body,
          url: "https://www.leverosintegra.com.br/Map/api/ShippingSimulation/V2",
        }).then((res) => {
          return res.data;
        });
        this.loader = false;
        let sla = [];
        if (simularFrete.freightSimulated.length > 0) {
          simularFrete.freightSimulated[0].slaResponseFreightSimulated.forEach(
            function (frete) {
              let preco_total = (frete.listPrice < frete.minimum_MoneyCost ? frete.minimum_MoneyCost : frete.listPrice);
              let pushSla = true;
              let _frete = {
                preco: preco_total,
                sla: frete.totalTime,
                tipo: frete.slaType,
                descricao: frete.slaTypeName,
                textoFrete: frete.slaTypeName !== 'Agendada' ? `${frete.slaType} - R$ ${preco_total
                  .toFixed(2)
                  .toString()
                  .replace(".", ",")} (Entrega em até ${
                  frete.totalTime
                } dias úteis)` : `${frete.slaType} - R$ ${preco_total
                  .toFixed(2)
                  .toString()
                  .replace(".", ",")} (Verificar datas disponíveis na tela de finalização)`,
              };

              // if (_frete.tipo == "Agendada") {
              //   _frete.textoFrete = `${_frete.tipo} - R$ ${(frete.listPrice < frete.minimum_MoneyCost ? frete.minimum_MoneyCost : frete.listPrice)
              //     .toFixed(2)
              //     .toString()
              //     .replace(".", ",")} (Entrega a combinar)`;
              // }
              if (sla.length == 0) {
                pushSla = true;
              } else if (sla.find((x) => x.tipo == frete.slaType) != null) {
                pushSla = false;
              }
              //Valida se Todos os produtos são atendidos pelo SLA disposto
              carrinho.forEach(function (c) {
                let slaCart =
                  simularFrete.freightSimulated[0].slaResponseFreightSimulated.find(
                    (x) => x.itemId == c.sku && x.slaType == _frete.tipo
                  );
                if (slaCart == null) {
                  pushSla = false;
                } else if (_frete.tipo != "Agendada") {
                  c.sla = slaCart.totalTime;
                  c.valorFrete = (slaCart.listPrice < slaCart.minimum_MoneyCost ? slaCart.minimum_MoneyCost : slaCart.listPrice);
                }
              });
              if (pushSla) {
                sla.push(_frete);
              }
            }
          );
        }
        localStorage.setItem("carrinho", JSON.stringify(carrinho));
        this.sla = sla;
        this.recuperarInfosProdutos();
      }
    },

    productDetails(sku, preco) {
      localStorage.setItem(
        "precoDetails",
        JSON.stringify({ preco: preco, sku: sku })
      );
      window.location.href = `details?sku=${sku}`;
    },
    addMiniCart(produto) {
      let totalItens = 0;
      let carrinho =
        localStorage.getItem("carrinho") != "" ||
        localStorage.getItem("carrinho") == null ||
        localStorage.getItem("carrinho") == undefined
          ? JSON.parse(localStorage.getItem("carrinho"))
          : [];
      let productAdd = {
        sku: produto.SKU,
        nomeItem: produto.Ds_Item,
        imagem: produto.ImagemItem,
        quantidade: 1,
        marca: produto.Marca,
        valor: produto.vl_liquido_produto,
        estoque: produto.estoque,
        
      };

      if (carrinho.length > 0) {
        let validarItem = carrinho.find((x) => x.sku == productAdd.sku);
        if (validarItem != undefined && validarItem != null) {
          carrinho.forEach(function (e) {
            if (e.sku == productAdd.sku) {
              e.quantidade = e.quantidade + 1;
            }
          });
        } else {
          carrinho.push(productAdd);
        }
      } else {
        carrinho.push(productAdd);
      }
      carrinho.forEach(function (e) {
        totalItens = parseFloat(totalItens) + parseFloat(e.quantidade);
      });
      localStorage.setItem("carrinho", JSON.stringify(carrinho));
      document.getElementsByClassName("header__quantity")[0].innerText =
        totalItens;
      document.getElementsByClassName("header__cart")[0].click();
    },

    async getDados() {
      try {
        let dados = JSON.parse(localStorage.getItem("login"));

        if (dados != undefined) {
          this.token = dados.token;
        } else {
          this.token = "";
        }

        try {
          this.loader = true;
          const response = await axios.get(
            `https://www.leverosintegra.com.br/MAP/api/ProdutoLista?tipo=maisvendidos&token=${this.token}`
          );
          this.infos = response.data.lcardapio;
          this.loader = false;
        } catch (e) {
          if (String(e).indexOf("Request failed with status code 500") >= 0) {
            alert("Seu login expirou ou você efetuou acesso em outra máquina;");
            localStorage.clear();
            let url = window.location.href;
            window.location.href = url;
          }
          console.log("erro", e);
          this.loader = false;
        }

      } catch (e) {
        console.log("Erro", e);
      }
    },

    maskCEP() {
      if (this.cep != null) {
        if (this.cep.length > 5) {
          let initialValue =
            this.cep.replace("-", "").length < 5
              ? this.cep.replace("-", "").length
              : 5;
          this.cep =
            this.cep.replace("-", "").substr(0, initialValue) +
            "-" +
            this.cep
              .replace("-", "")
              .substr(5, this.cep.replace("-", "").length);
        }
      }
    },
  },

  beforeMount() {
    if (localStorage.getItem("carrinho") == null) {
      localStorage.setItem("carrinho", []);
    }
    this.saleChannel = localStorage.getItem("saleChannel");
    this.isSaleSolar  = JSON.parse(localStorage.getItem("isSaleSolar"));
    this.recuperarInfosProdutos();
    this.calculaTotalCarrinho();
    this.getDados();
  },
};
</script>

<style lang="scss" scoped>
.loader {
  padding-top: 20px;
  display: flex;
  align-items: center;

  i {
    color: var(--customBlue);
  }

  span:nth-child(2) {
    font-size: 0.95rem;
    padding-left: 10px;
  }
}
.cart {
  max-width: 95%;
  margin: 0 auto;

  @media (min-width: 769px) {
    max-width: 80%;
  }

  &__title {
    display: none;

    @media (min-width: 769px) {
      display: block;
      color: var(--standardGreen);
      letter-spacing: 0.3px;
      font: 800 1.4rem "Soleto", sans-serif;
    }
  }

  &__items {
    width: 100%;

    @media (min-width: 769px) {
      width: 57%;
    }
  }

  &__summary {
    width: 100%;
    position: sticky;
    height: 100%;
    top: 0;

    @media (min-width: 769px) {
      width: 40%;
    }
  }

  &__values {
    background: var(--customWhite);
    box-shadow: 0 2px 2px 0 rgb(0 0 0 / 10%);
    border-radius: 5px;
    margin-top: 30px;
    padding: 20px;

    @media (min-width: 769px) {
      background: var(--customGray-70);
    }
  }

  .header {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    flex-direction: column;

    @media (min-width: 769px) {
      margin-top: 35px;
      flex-direction: row;
    }
  }

  .product {
    margin: 30px 0;
    border: 1px solid var(--customGray-100);
    background: var(--customWhite);
    border-radius: 5px;
    box-shadow: 0 2px 2px 0 rgb(0 0 0 / 10%);
    padding: 20px;

    &__details {
      display: flex;
      align-items: center;
    }

    &__controller {
      border-top: 2px solid var(--customGray-100);
      margin-top: 15px;
      padding-top: 10px;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
  }

  .details {
    &__image {
      cursor: pointer;
    }
    &__infos {
      margin-left: 10px;

      p {
        font-size: 0.875rem;
        color: var(--customGray-500);
        padding: 5px 0;

        a {
          cursor: pointer;
          font: 700 0.95rem/1.4 "Soleto", sans-serif;
        }

        strong {
          color: var(--standardGreen);
        }
      }
    }
  }

  .controller {
    &__quantity {
      display: flex;
      align-items: center;

      p {
        color: var(--customGray-500);
        margin-right: 10px;
        display: none;
        font: 700 0.95rem "Soleto", sans-serif;

        @media (min-width: 769px) {
          display: block;
        }
      }

      button {
        border: 2px solid var(--customGray-200);
        width: 30px;
        height: 30px;
        border-radius: 15px;
        color: var(--customGray-500);
        font-weight: 800;
        outline: none;
      }

      input {
        width: 20%;
        height: 35px;
        border: 1px solid var(--customGray-100);
        border-radius: 10px;
        margin: 0 10px;
        outline: none;
        text-align: center;
        color: var(--customDarkGreen);
        font: 700 0.95rem "Soleto", sans-serif;

        @media (min-width: 769px) {
          width: 10%;
        }
      }
    }

    &__values {
      p {
        font-weight: 700;
        color: var(--customGray-800);
      }
    }
  }

  .freight {
    margin-top: 45px;
    background: var(--customWhite);
    padding: 10px;

    @media (min-width: 769px) {
      padding: 0;
    }
    &__title {
      color: var(--customGray-500);
      font-size: 1.1rem;
      letter-spacing: 0.3px;
    }

    &__form {
      margin-top: 25px;
      display: flex;
      align-items: center;

      input {
        border: 1px solid var(--customGray-100);
        border-radius: 5px;
        padding: 15px;
        outline: none;
        color: var(--customGray-500);
      }

      button {
        margin: 0 10px;
        border: 1px solid var(--customGray-500);
        border-radius: 5px;
        padding: 15px;
        color: var(--customGray-500);
        font: 700 0.95rem "Soleto", sans-serif;
      }

      p {
        display: none;

        @media (min-width: 769px) {
          display: block;
        }
        a {
          font-size: 0.75rem;
          color: var(--customGray-500);
        }
      }
    }

    &__result {
      background: var(--customWhite);
    }
  }

  .summary {
    &__item {
      display: flex;
      justify-content: space-between;
      padding: 20px 0;
      border-bottom: 2px solid var(--customGray-100);
    }

    &__buttons {
      margin-top: 30px;
      display: flex;
      flex-direction: column;
    }

    &__continue {
      background: var(--standardGreen);
      color: var(--customWhite);
      padding: 15px;
      text-align: center;
      text-decoration: none;
      font-weight: 700;
      letter-spacing: 0.5px;
      border-radius: 5px;
    }

    &__buyMore {
      margin-top: 20px;
      border: 1px solid var(--standardGreen);
      color: var(--standardGreen);
      padding: 12px;
      text-align: center;
      text-decoration: none;
      font-weight: 700;
      letter-spacing: 0.5px;
      border-radius: 5px;
    }
  }

  .item {
    &__label {
      font: 700 0.95rem "Soleto", sans-serif;
      color: var(--customGray-500);
    }

    &__value {
      font-weight: 700;
      color: var(--customGray-800);
    }
  }

  .buyMore {
    margin-top: 40px;
    padding: 10px;
    background: var(--customWhite);

    @media (min-width: 769px) {
      padding: 0;
    }

    &__title {
      color: var(--customDarkGreen);
      font-size: 1.2rem;
    }
    .products {
      margin-top: 40px;

      &__item {
        display: flex;
        flex-wrap: wrap;
        justify-content: flex-start;
        color: var(--customGray-500);
        width: 100%;
        margin-top: 0;
      }

      &__loader {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        margin: 0 auto;

        i {
          color: var(--customBlue);
          margin-top: 30px;
        }

        span:nth-child(2) {
          padding-top: 10px;
          font-size: 0.95rem;
        }
      }

      &__list {
        width: 100%;
        margin: 3px;
        border: 1px solid var(--customGray-100);
        border-radius: 5px;
        padding: 25px 0;

        @media (min-width: 360px) and (max-width: 767px) {
          width: 48%;
        }

        @media (min-width: 768px) and (max-width: 1024px) {
          width: 30%;
        }

        @media (min-width: 1025px) {
          width: 24%;
        }

        a {
          display: flex;
          justify-content: center;
          text-decoration: none;
          cursor: pointer;
        }

        &:hover {
          border: 1px solid var(--standardGreen);
          background: linear-gradient(
            10deg,
            rgba(0, 90, 100, 0.2839110644257703) 0%,
            rgba(0, 90, 100, 0.014) 45%
          );
        }
      }

      &__stamp {
        position: absolute;
        height: 22px;
        width: 25px;
        border-radius: 50%;
        background-color: #4cdddd9a;
        color: var(--customWhite);
        text-align: center;
        font-weight: 900;
        font-family: inherit;
      }

      &__image {
        max-width: 220px;
        height: auto;
      }

      &__name {
        text-align: center;
        padding: 20px 0;
        font-size: 1rem;
      }

      &__price {
        display: flex;
        flex-direction: column;
        padding-left: 10px;

        @media (min-width: 441px) {
          padding-left: 15px;
        }
      }

      &__pricePer {
        color: var(--standardGreen);
        font: 700 1.3rem "Soleto", sans-serif;
      }

      &__AtSight {
        font-size: 0.85rem;
      }

      &__priceTerm {
        padding: 3px 0;
        font-size: 0.95rem;
      }

      &__plots {
        font-size: 0.95rem;
      }

      &__lower-quantity {
        background-color: #ff000030;
        border-radius: 2px;
        width: 90%;
        margin: 15px 0 0 0;
        padding: 3px 0;
        text-align: center;
        font-size: 0.85rem;
      }

      &__buttons {
        padding-top: 30px;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-wrap: wrap;
        flex-direction: column-reverse;

        @media (min-width: 1309px) {
          flex-direction: row;
        }

        &--details {
          border: 1px solid var(--customDarkGreen);
          border-radius: 5px;
          color: var(--customDarkGreen);
          font-size: 0.95rem;
          outline: none;
          margin: 10px 3px;
          width: 95%;
          padding: 11px;

          @media (min-width: 1309px) {
            margin: 0 10px;
            padding: 7px;
            width: initial;
          }
        }

        &--buy {
          background-color: var(--standardGreen);
          border-radius: 5px;
          color: var(--customWhite);
          font: 700 0.95rem "Soleto", sans-serif;
          outline: none;
          width: 95%;
          padding: 13px;

          @media (min-width: 1309px) {
            width: initial;
            padding: 7px;
          }
        }
      }
    }
  }
}
</style>